module.exports = __webpack_public_path__ + "img/mobile-notch.ad003ba6.svg";